export const NotFoundPage = () => {
  return (
    <h1>qwe</h1>
  )
}